const initialState = {
  queue: [],
  active: [], // Array of currently displayed notifications
  maxActive: 5, // Maximum number of notifications to show simultaneously
};

// Generate unique ID for each notification
const generateId = () =>
  `snackbar_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

//snackbar queue reducer
export default function snackbarReducer(state = initialState, action) {
  switch (action.type) {
    case "snackbar/add": {
      const newNotification = {
        id: generateId(),
        message: action.payload.message,
        severity: action.payload.severity || "success",
        timestamp: Date.now(),
      };

      // If we have space in active notifications, add directly
      // Otherwise add to queue
      if (state.active.length < state.maxActive) {
        return {
          ...state,
          active: [...state.active, newNotification],
        };
      } else {
        return {
          ...state,
          queue: [...state.queue, newNotification],
        };
      }
    }

    case "snackbar/remove": {
      const updatedActive = state.active.filter(
        (notification) => notification.id !== action.payload.id
      );

      // Move notifications from queue to active if there's space
      const availableSlots = state.maxActive - updatedActive.length;
      const notificationsToActivate = state.queue.slice(0, availableSlots);
      const remainingQueue = state.queue.slice(availableSlots);

      return {
        ...state,
        active: [...updatedActive, ...notificationsToActivate],
        queue: remainingQueue,
      };
    }

    case "snackbar/clear":
      return {
        ...state,
        queue: [],
        active: [],
      };

    // Legacy support for existing code
    case "snackbar/update": {
      const legacyNotification = {
        id: generateId(),
        message: action.payload.message,
        severity: action.payload.severity || "success",
        timestamp: Date.now(),
      };

      // If we have space in active notifications, add directly
      if (state.active.length < state.maxActive) {
        return {
          ...state,
          active: [...state.active, legacyNotification],
        };
      } else {
        return {
          ...state,
          queue: [...state.queue, legacyNotification],
        };
      }
    }

    case "snackbar/close":
      // Legacy - remove the first active notification
      if (state.active.length > 0) {
        const [, ...remainingActive] = state.active;
        const availableSlots = state.maxActive - remainingActive.length;
        const notificationsToActivate = state.queue.slice(0, availableSlots);
        const remainingQueue = state.queue.slice(availableSlots);

        return {
          ...state,
          active: [...remainingActive, ...notificationsToActivate],
          queue: remainingQueue,
        };
      }
      return state;

    default:
      return state;
  }
}
